"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = ToggleMenuItem;
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _Anchor = _interopRequireDefault(require("../../../../Atoms/Anchor"));
var _common = require("../../../../../core/utils/common");
function ToggleMenuItem(_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? '' : _ref$customClass,
    _ref$expand = _ref.expand,
    expand = _ref$expand === void 0 ? false : _ref$expand,
    _ref$up = _ref.up,
    up = _ref$up === void 0 ? '' : _ref$up,
    _ref$down = _ref.down,
    down = _ref$down === void 0 ? '' : _ref$down,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? false : _ref$showIcon;
  return _react.default.createElement(_react.default.Fragment, null, url ? _react.default.createElement(_Anchor.default, {
    to: (0, _common.urlSanitize)(url),
    title: title,
    className: "cmp-mobile-navigation__group__container--link"
  }, title) : _react.default.createElement("div", {
    className: "cmp-mobile-navigation__group__container--text"
  }, title), showIcon && _react.default.createElement("div", {
    className: "cmp-mobile-navigation__group__container--icons " + customClass
  }, expand ? _react.default.createElement("div", {
    className: "arrow up"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    src: up
  })) : _react.default.createElement("div", {
    className: "arrow down"
  }, _react.default.createElement(_reactSvg.ReactSVG, {
    src: down
  }))));
}
module.exports = exports["default"];